var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"ui-input-text_old",attrs:{"type":_vm.type,"autofocus":_vm.isAutofocus},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateSelf($event.target.value)},"blur":function($event){return _vm.$emit('blur')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }